{
  "page": {
    "title": "Help",
    "intro": "Short guides for the main jobs and the meaning of the words of tax and the law.",
    "guides": "30-second guides",
    "topics": "What does this word mean?",
    "back": "All help",
    "not_found": "This help page does not exist.",
    "english_only": "This page is not written in your language yet — here it is in English.",
    "tour_again": "Show the tour of the home page again",
    "checklist_again": "Show “Get your shop ready” on the home page",
    "checklist_shown": "The list is back on the home page.",
    "tour_reset": "The tour starts the next time you open the home page.",
    "tools": "Help tools",
    "open_guide": "Guide for this page"
  },
  "checklist": {
    "title": "Get your shop ready",
    "intro": "Set these up once. Each step turns green by itself when it is done.",
    "progress": "{{done}} of {{total}} done",
    "hide": "Hide this list",
    "hidden": "The list is hidden. Help → “Show Get your shop ready” brings it back.",
    "all_done": "Your shop is ready. You can hide this list.",
    "go": "Set up",
    "open": "Open",
    "status": {
      "done": "Done",
      "todo": "To do",
      "unknown": "Could not check",
      "no_access": "Ask the owner"
    },
    "items": {
      "store": {
        "title": "Shop details",
        "body": "Name, address, phone and e-mail — used on the legal pages and in e-mails. The logo is in the website design."
      },
      "tokushoho": {
        "title": "Legal notice page (特商法表記)",
        "body": "The 14 items; complete when all are filled ({{percent}} % now)."
      },
      "tax": {
        "title": "Tax: registration number and sales abroad",
        "body": "Your T-number and how prices abroad are shown."
      },
      "payments": {
        "title": "Ways to pay: bank account and card terminal",
        "body": "The bank account customers transfer to, and your card terminal with its fee %."
      },
      "shipping": {
        "title": "Shipping: Japan and abroad",
        "body": "At least one way to ship inside Japan and one to other countries."
      },
      "register": {
        "title": "Shop register",
        "body": "One register, paired with its tablet."
      },
      "first_card": {
        "title": "Your first card",
        "body": "Add a card in about 2 minutes."
      },
      "staff": {
        "title": "Your staff",
        "body": "Add the people who work with you, each with their own sign-in."
      },
      "two_step": {
        "title": "Two-step sign-in for you",
        "body": "A code from your phone app at every sign-in keeps the shop safe."
      }
    }
  },
  "coach": {
    "label": "Tour of the home page",
    "step": "{{n}} of {{total}}",
    "next": "Next",
    "done": "Got it",
    "skip": "Skip the tour",
    "list_title": "Three things to know",
    "big_actions": {
      "title": "The big buttons",
      "body": "The jobs of every day: add a card, orders to send, take cards in, open the register."
    },
    "search": {
      "title": "Find anything",
      "body": "Type a card name, an order number or scan a code. On a keyboard: Ctrl + K."
    },
    "inbox": {
      "title": "To-do list",
      "body": "The bell shows what needs you: money to check, orders to send, problems. Red = urgent."
    }
  },
  "feedback": {
    "button": "Report a problem or idea",
    "title": "Tell us about a problem or an idea",
    "kind": "What is it?",
    "kind_problem": "Something does not work",
    "kind_idea": "An idea to make it easier",
    "message": "What happened, or what would help?",
    "message_hint": "Please do not type customers' names, addresses or card numbers.",
    "message_required": "Write a few words first.",
    "attached": "Sent with it: this page, the time and the reference of the last problem ({{requestId}}).",
    "attached_none": "Sent with it: this page and the time.",
    "send": "Send",
    "sent": "Thank you — it was sent.",
    "email_instead": "Send by e-mail instead",
    "no_channel": "Reports cannot be sent from here yet. Use e-mail:",
    "failed": "It could not be sent. Try again, or use e-mail."
  },
  "usability": {
    "title": "Usability test (observer)",
    "panel": "Usability test panel (observer only)",
    "start": "Start task {{n}}",
    "done": "Done",
    "gave_up": "Gave up",
    "download_one": "Download the results ({{count}} task)",
    "download_other": "Download the results ({{count}} tasks)"
  }
}
